// had to do this for svg issues with jest, will revisit when time allows
import { isArray, omitBy } from 'lodash';

export const viewExclusions = (preference, eligibilityRules) => {
  const {
    hasAllViewOnlyMutualFund,
    hasAllViewOnlyBrokerage,
    hasAllViewOnlyNational529,
    hasAllViewOnlyMaryland529,
    hasAllViewOnlyAlaska529,
    hasAllViewOnlyActivePlus,
    hasMaryland529,
    hasMutualFunds,
    hasAlaska529,
    hasNational529,
    hasActivePlus,
    hasBrokerage
  } = eligibilityRules;

  const { section, isEligible } = preference;

  if (section === 'generalInvesting') {
    if (
      hasMutualFunds &&
      isEligible(eligibilityRules) &&
      !hasAllViewOnlyMutualFund
    ) {
      return true;
    }
    if (
      hasBrokerage &&
      isEligible(eligibilityRules) &&
      !hasAllViewOnlyBrokerage
    ) {
      return true;
    }
  }
  if (section === 'trpCollegeSavings') {
    if (
      hasNational529 &&
      isEligible(eligibilityRules) &&
      !hasAllViewOnlyNational529
    ) {
      return true;
    }
  }
  if (section === 'mdCollegeSavings') {
    if (
      hasMaryland529 &&
      isEligible(eligibilityRules) &&
      !hasAllViewOnlyMaryland529
    ) {
      return true;
    }
  }
  if (section === 'akCollegeSavings') {
    if (
      hasAlaska529 &&
      isEligible(eligibilityRules) &&
      !hasAllViewOnlyAlaska529
    ) {
      return true;
    }
  }
  if (section === 'activePlus') {
    if (
      hasActivePlus &&
      preference.isEligible(eligibilityRules) &&
      !hasAllViewOnlyActivePlus
    ) {
      return true;
    }
  }
  return false;
};

export const removeUnchangedSelections = (
  preference,
  existingSelections,
  currentSelections
) => {
  const { serviceTypeId } = preference;

  const preferenceIds =
    serviceTypeId && isArray(serviceTypeId) ? serviceTypeId : [serviceTypeId];
  const changeIds = omitBy(currentSelections, (selection, id) => {
    const compare =
      existingSelections[id] && existingSelections[id] == selection;
    return compare;
  });

  const found = Object.keys(changeIds).some((changed) => {
    const changeId = parseInt(changed);
    return preferenceIds.indexOf(changeId) >= 0;
  });

  return found;
};

export default viewExclusions;
